import { render, staticRenderFns } from "./OpeningHoursViolations.vue?vue&type=template&id=5a6c7422"
import script from "./opening-hours-violations.js?vue&type=script&lang=js&external"
export * from "./opening-hours-violations.js?vue&type=script&lang=js&external"
import style0 from "./opening-hours-violations.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports